(function() {
  function handleLogoutEvent(event) {
    event.preventDefault();
    var href = event.currentTarget.getAttribute('href');
    
    if (href && href.length) {
      fetch(href, {
        method: 'GET',
        headers: {}
      })
      .then((res) => {
        window.location.href = '/';
      });
    }
  }
  
  function init() {
    var logoutLinks = document.querySelectorAll('a[href^="/account/logout"]');
    
    if (logoutLinks.length) {
      for (var i=0; i<logoutLinks.length; i++) {
        var link = logoutLinks[i];
        link.addEventListener('click', handleLogoutEvent);
      }
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();